import { createI18nInstance } from "@/config";

let lastSrcs; // 上一次获取到的 script 地址
const scriptRegx = /\<script.*src=["'](?<src>[^"']+)/gm;
let isChecking = false; // 状态标志，表示是否正在检查更新

// 获取最新页面中的 script 链接
function extractNewScripts() {
  return new Promise(async (resolve, reject) => {
    try {
      const locationURL = new URL(location.href);
      const r1 = await fetch(
        locationURL.origin + locationURL.pathname + "?_timestamp=" + Date.now()
      );
      if (!r1.ok) {
        throw new Error(`Fetch failed with status: ${r1.status}`);
      }
      // 请求成功，解析响应文本
      const html = await r1.text();
      scriptRegx.lastIndex = 0;
      let result = [];
      let match;
      while ((match = scriptRegx.exec(html))) {
        result.push(match.groups.src);
      }
      resolve(result);
    } catch (error) {
      console.error("Error extracting new scripts:", error);
      reject(error);
    }
  });
}

function needUpdate() {
  return new Promise(async (resolve, reject) => {
    try {
      const newSrcipts = await extractNewScripts();
      if (!lastSrcs) {
        lastSrcs = newSrcipts;
        reject("No previous script sources to compare.");
      }
      let result = false;
      if (lastSrcs.length !== newSrcipts.length) {
        resolve(true);
      }
      for (let i = 0; i < lastSrcs.length; i++) {
        if (lastSrcs[i] !== newSrcipts[i]) {
          result = true;
          break;
        }
      }
      lastSrcs = newSrcipts;
      result ? resolve() : reject("No updates found.");
    } catch (error) {
      console.error("Error checking for updates:", error);
      reject(error);
    }
  });
}

async function autoRefresh() {
  if (isChecking) return; // 如果正在检查更新，则不再执行
  isChecking = true; // 设置状态标志
  try {
    const i18n = await createI18nInstance();
    const { t } = i18n.global;
    await needUpdate();
    // const result = confirm(t("A0350")); // 提示用户是否刷新页面
    // if (result) {
    //   location.reload();
    // }
    location.reload();

  } catch (error) {
    // console.error("Error during auto refresh:", error);
  } finally {
    isChecking = false; // 重置状态标志
    // setTimeout(autoRefresh, 10000); // 每 10 秒检测一次
  }
}

// autoRefresh();

export { autoRefresh };
